module.exports = __webpack_public_path__ + "img/miniatura.8704bfdc.png";